<nb-layout>
  <nb-layout-header fixed>
    <div class="header">
      <div class="header-container">
        <div class="logo-container">
          <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
          </a>
          <a class="logo" href="/">
            @if (isAdmin) {
              <img
                [src]="uploadBaseUrl + 'qwintal.png'"
                alt="Logo"
                style="max-width: 256px; max-height: 68px"
                />
            }
            @if (!isAdmin && company && company.logo) {
              <img
                [src]="uploadBaseUrl + company.logo"
                alt="Logo"
                style="max-height: 68px"
                />
            }
          </a>
        </div>
      </div>
      <div class="header-container">
        <nb-actions>
          @for (animalType of displayAnimalTypeSelector ? animalTypeOptions : []; track animalType) {
            <nb-action
              class="control-item p-0"
              (click)="selectAnimalType(animalType.id)"
              (mouseenter)="onAnimalTypeMouseEnter(animalType.id)"
              (mouseleave)="onAnimalTypeMouseLeave(animalType.id)"
              >
              <nb-icon
                class="animal-type-icon"
                [icon]="getAnimalTypeIcon(animalType.id)"
                pack="custom"
                [attr.aria-label]="animalType.label"
                >
              </nb-icon>
            </nb-action>
          }
          <nb-action class="control-item p-0 logout-action" (click)="logoutAction()">
            <nb-icon icon="q-logout" class="ico-logout" pack="custom"></nb-icon>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </nb-layout-header>

  <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
    @if (companyName) {
      <div class="company-header">
        <h6 class="company-name">{{ companyName }}</h6>
        @if (!isAdmin && hasMultipleCompanies()) {
          <button
            nbButton
            shape="round"
            size="tiny"
            status="primary"
            title="Changer d'exploitation"
            class="change-company-btn"
            (click)="openCompanySelectorDialog()"
            >
            <span class="btn-text">Changer</span>
          </button>
        }
        @if (!isAdmin && hasMultipleCompanies()) {
          <button
            nbButton
            status="primary"
            size="small"
            class="transparent-button bt-primary-color"
            (click)="openCompanySelectorDialog()"
            title="Changer d'exploitation"
            >
            <nb-icon icon="q-change-expl" pack="custom"></nb-icon>
          </button>
        }
      </div>
    }
    <nb-menu [items]="menu"></nb-menu>
    <!-- Téléphone : la déconnexion quitte l'en-tête, trop étroit, pour le menu -->
    <nb-menu class="logout-menu" tag="logout-menu" [items]="logoutMenu"></nb-menu>
  </nb-sidebar>

  <nb-layout-column class="layout-background">
    <router-outlet></router-outlet>
  </nb-layout-column>

  <nb-layout-footer fixed>
    <!-- Insert footer here -->
  </nb-layout-footer>
</nb-layout>
